window.addEventListener('DOMContentLoaded', () => {

  // Look for carousels and loop through them
  const carousels = document.querySelectorAll('.carousel');
  carousels.forEach(function(carousel) {
      // Find slides within carousel
      const slides = carousel.querySelectorAll('.slide');
      slides.forEach(function(slide) {
        const slideComponentContent = slide.querySelector('.component.content');
        if ( slideComponentContent && slideComponentContent.classList.contains('text-light')) {
          carousel.classList.add('text-light');
          carousel.classList.remove('text-dark');
        } else {
          carousel.classList.add('text-dark');
          carousel.classList.remove('text-light');
        }
        
        // Listen for a display: none; event on slides of carousels
        var observer = new MutationObserver( function () {
          if (slide.style.display != 'none'){
            // When display: none; occurs add or remove text-color class to parent carousel based on slide's class
            let carousel = slide.closest('.carousel');
            if (slideComponentContent && slideComponentContent.classList.contains('text-light')) {
              carousel.classList.add('text-light');
              carousel.classList.remove('text-dark');
            } else {
              carousel.classList.add('text-dark');
              carousel.classList.remove('text-light');
            }
          }
        });
      observer.observe(slide, { attributes: true, childList: true });
    });
  });

})